
import { Edit, required, SimpleForm, TextInput, useRecordContext, useTranslate } from "react-admin";
import { EditToolbar } from "../../common/EditToolbar";
import useIsPermission from '../../hooks/useIsPermission';

const BannerCategoriesEdit = () => {
    const { isUpdatable } = useIsPermission("BANNERS");
    return (
        <Edit mutationMode={'pessimistic'} title={<BannerTitle />}>
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="name" fullWidth validate={[required()]} />
            </SimpleForm>
        </Edit>
    )
}

const BannerTitle = () => {
    const record = useRecordContext<any>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.banner_categories.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default BannerCategoriesEdit;
